module.exports = __webpack_public_path__ + "static/Knowbe4-6aa4d65bbb38eea9768a0d36b27a2a72.jpg";